import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 16,
  },
}));

export default useStyles;
